'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ', 'px;\n  height: ', 'px;\n  background-image: url(', ');\n  background-position: 0 0;\n  background-repeat: repeat;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ', 'px;\n  height: ', 'px;\n  background-image: url(', ');\n  background-position: 0 0;\n  background-repeat: repeat;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/** @class PatternLayer
  * A layer sized to the stage that consists of a repeated
  * (tiled) image pattern.
  * @prop {url} image - the image to repeat
  * @prop {number} width - the width of the stage to cover in pixels
  * @prop {number} height - the height of the stage to cover in pixels
  */
var PatternLayer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.image;
});

exports.default = PatternLayer;


PatternLayer.propTypes = {
  image: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/pattern-layer.js
// module id = 1191
// module chunks = 0